import { initUtils, retrieveLaunchParams } from "@telegram-apps/sdk";

export default function openLinkInTelegram(url: string) {
    try {
        const utils = initUtils();
        const launchParams = retrieveLaunchParams();
        if (url) return utils.openLink(url);
        if (url.includes("t.me")) {
            utils.openTelegramLink(url);
            return;
        } else if (
            launchParams.platform == "ios" ||
            launchParams.platform == "android" ||
            launchParams.platform == "web" ||
            launchParams.platform == "weba"
        ) {
            window.open(url, "_blank");
        } else {
            utils.openLink(url);
        }
    } catch (e) {
        window.open(url, "_blank");
    }
}
